import * as React from 'react';
import { useCallback, useRef } from 'react';
import { serviceTypeToComponent } from './serviceTypeToComponent';
import * as styles from './Services.css';
import { useServices } from './hooks';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { useScrollTo } from '../../../../../../../hooks';
import { useServicesAnalyticsHandlers } from '../hooks';
import { selectDisablePromotionSection } from '../../../../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

export const Services = () => {
  const { services, selectService } = useServices();
  const root = useRef<HTMLDivElement>(null);
  const scrollTo = useScrollTo(root);
  const { onServiceChange } = useServicesAnalyticsHandlers();
  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);

  const handleSelect = useCallback(
    (serviceType: EServiceId) => {
      selectService(serviceType);
      scrollTo(serviceType);

      onServiceChange();
    },
    [onServiceChange, scrollTo, selectService],
  );

  return (
    <div className={classNames(styles.root, allowDisablePromotionSection && styles.disabled)} ref={root}>
      {services.map(service => {
        const Service = serviceTypeToComponent[service.type];

        return <Service {...service} key={service.type} onSelect={handleSelect} />;
      })}
    </div>
  );
};
